<template>
    <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{ $t('currency.form.information') }}</h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-md-12">
              <TextField 
                :placeholder="$t('currency.form.symbol.placeholder')"
                :label="$t('currency.form.symbol.label')"
                v-model="model.symbol"
              />
            </div>

            <div class="col-md-12">
              <TextField 
                :placeholder="$t('currency.form.code.placeholder')"
                :label="$t('currency.form.code.label')"
                v-model="model.code"
              />
            </div>

            <div class="col-md-12">
              <TextField 
                :placeholder="$t('currency.form.name.placeholder')"
                :label="$t('currency.form.name.label')"
                v-model="model.name"
              />
            </div>

          </div>

          <div class="row">

            <div class="col-md-12">
              <div class="form-group">
                <div class="textOnInput">
                  <label for="remarks" class="form-label">{{ $t('currency.form.remarks.placeholder') }}</label>
                  <textarea
                    class="form-control" 
                    name="remarks"
                    :placeholder="$t('currency.form.remarks.placeholder')"
                    rows="5"
                    v-model="model.remarks"
                  />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextField from '@components/form2/textfield.vue'
import  FormMixin from '@mixins/form'

import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField
  },
  mixins: [ FormMixin ],
  data () {
    return {
      model: {}
    }
  },
  validations: {
    model:{
      symbol: { required },
      code: { required },
      name: { required }
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    currencyID() {
      let parameters = this.parameters || {}
      return parameters.currencyID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.currencyID

      return this.$store.dispatch('currency/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    currencyID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    },
  },
  mounted() {
    if (this.currencyID) {
      this.fetchData()
    }
  }
}
</script>